var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-09-22
 * @brief EHP 사용자 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
//
import { useAsync } from "react-async";
// recoil && state
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
//
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useNavigate } from "react-router-dom";
import EhpPagination from "../../common/pagination/EhpPagination";
/**
 * @brief EHP 사용자 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
export default function UserView(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //화면 이동
    const navigate = useNavigate();
    //props
    const setParentPopWin = props.setPopWin;
    const selTree = props.selTree;
    const setSelTree = props.setSelTree;
    //페이징
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    //사업장 선택
    const [zoneSel, setZoneSel] = useState([]);
    const [zoneName, setZoneName] = useState('');
    const roleDto = [
        { id: "0", value: "", fname: "전체", /* active: false */ },
        { id: "1", value: "ROLE_ADMIN", fname: "Admin", /* active: false */ },
        { id: "2", value: "ROLE_ENGINEER", fname: "Engineer", /* active: false */ },
        { id: "3", value: "ROLE_USER", fname: "User", /* active: false */ },
        { id: "4", value: "ROLE_NONE", fname: "Non-User", /* active: false */ },
    ];
    const [role, setRole] = useState('');
    //
    const [users, setUsers] = useState(null);
    //
    // 승인 요청 
    const [item, setItem] = useState(null);
    const [approvalNo, setApprovalNo] = useState("");
    const [userDisplayDone, setUserDisplayDone] = useState(false);
    const [userDisplayCompanion, setUserDisplayCompanion] = useState(false);
    //ApprovalPop
    const [companyItem, setCompanyItem] = useState([]);
    const [zoneItem, setZoneItem] = useState([]);
    const [addListResult, setAddListResult] = useState([]);
    const [addListResultData, setAddListResultData] = useState([]);
    const [checked, setChecked] = useState(false);
    const [userType, setUserType] = useState("");
    const [companionTxt, setCompanionTxt] = useState("");
    const [errorList, setErrorList] = useState([]);
    const [userTypeItme, setUserTypeItme] = useState("");
    //ApprovalPop - site addPop
    const [companyAdd, setCompanyAdd] = useState([]);
    const [zoneAdd, setZoneAdd] = useState([]);
    const [addList, setAddList] = useState([]);
    // 
    const [load, setload] = useState(false);
    const [reload, setReload] = useState(false);
    const [enableItem, setEnableItem] = useState(false);
    const [enableType, setEnableIType] = useState(false);
    const [userLoad, setUserLoad] = useState(false);
    const [password, setPassword] = useState("");
    const [userDel, setUserDel] = useState(null);
    const [sortData, setSortData] = useState({ "sortField": "rownumber", "sort": "ASC" });
    //
    let appPath = "companyName=" + selTree.company.companyName + '&page=' + pageInfo.number + '&size=' + pageInfo.size;
    appPath = appPath + '&sort=' + sortData.sortField + ',' + sortData.sort;
    // 사업장 조회
    if (!CUTIL.isnull(zoneName) && (zoneName.length > 0)) {
        appPath = appPath + '&zoneName=' + zoneName;
        // clog("사업장 조회 : " + appPath);
    }
    // 사용자 Type 조회
    if (!CUTIL.isnull(role) && (role.length > 0)) {
        appPath = appPath + '&role=' + role;
        // clog("사용자 Type 조회 : " + appPath);
    }
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/users?${appPath}`,
        userToken: userInfo.loginInfo.token,
        watch: appPath + selTree.reload + reload + enableItem + userLoad + load
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setUsers(data.body);
                setPageInfo(data.data.page);
            }
            else {
                if (data.errorList.filter((err) => (err.field == "companyName"))) {
                    window.location.reload();
                }
                else {
                    const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
                    if (ERR_URL.length > 0)
                        navigate(ERR_URL);
                }
                // setErrorList()
            }
        }
    }, [data]);
    // 페이징
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    function onClickSort(e) {
        var actTag = (e.target.tagName == "TH") ? e.target : e.currentTarget;
        var selSortField = actTag.getAttribute("data-value");
        var selSort = (sortData.sort === "ASC") ? "DESC" : "ASC";
        if (selSortField !== sortData.sortField) { // 정렬필드가 변경된 경우
            selSort = "DESC";
        }
        //setCurPage(0); // 페이지 초기화
        handleCurPage(0);
        setSortData({
            "sortField": selSortField,
            "sort": selSort
        });
    }
    //
    // 사업장 선택 API
    function zoneOnSel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                promiseFn: HTTPUTIL.PromiseHttp,
                httpMethod: "GET",
                appPath: `/api/v2/user/zones?companyName=${selTree.company.companyName}`,
                // appQuery: {
                //   companyName: 
                // },
                userToken: userInfo.loginInfo.token,
                watch: selTree.company.companyName + selTree.rolad
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setZoneSel(data.body);
                }
            }
        });
    }
    // 신규 가입자 승인 요청 API
    function approvalPop(e, list) {
        CUTIL.jsopen_Popup(e);
        setItem(list);
        if (list.approval == 2) {
            setUserDisplayCompanion(false);
            setUserDisplayDone(true);
        }
        else if (list.approval == 3) {
            setUserDisplayDone(true);
        }
        else {
            setUserDisplayCompanion(false);
        }
        setUserLoad(false);
    }
    // <!-- 신규 가입 요청 팝업 --> 
    useEffect(() => {
        if (CUTIL.isnull(item))
            return;
        setParentPopWin("pop-userjoin-ok", React.createElement(RequestApproval, { htmlHeader: (item) && (React.createElement("h1", null, (item.approval == 3 || item.enable == true) ? item.userName : item.userName + "(미인증)")), htmlHeaderBtn: (item) && React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => close(e) },
                React.createElement("span", { className: "hide" }, "\uB2EB\uAE30")), userInfo: userInfo, item: item, setItem: setItem, setload: setload, approvalNo: approvalNo, addListResult: addListResult, setAddListResult: setAddListResult, addListResultData: addListResultData, setAddListResultData: setAddListResultData, setPassword: setPassword, checked: checked, setChecked: setChecked, userType: userType, setUserType: setUserType, userDisplayDone: userDisplayDone, setUserDisplayDone: setUserDisplayDone, userDisplayCompanion: userDisplayCompanion, setUserDisplayCompanion: setUserDisplayCompanion, companionTxt: companionTxt, setCompanionTxt: setCompanionTxt, roleDto: roleDto, errorList: errorList, setErrorList: setErrorList, setEnableIType: setEnableIType, setAddList: setAddList, 
            //
            reload: reload, setReload: setReload, setEnableItem: setEnableItem, setUserDel: setUserDel, enableItem: enableItem, setUserTypeItme: setUserTypeItme, userLoad: userLoad, setUserLoad: setUserLoad, 
            //
            companySelect: companySelect, approvalChang: approvalChang, listDelete: listDelete, usertypeSelect: usertypeSelect, onCompanion: onCompanion, onDone: onDone, 
            //
            userApprovalDone: userApprovalDone }));
    });
    // <!-- 신규 가입자 정보 팝업 (웹,탭용 팝업) --> 
    useEffect(() => {
        setParentPopWin("pop-userjoin-info", React.createElement(SiteCeatePop, { htmlHeader: (item) && React.createElement("h1", null, item.userName), item: item, companyItem: companyItem, zoneItem: zoneItem, companyAdd: companyAdd, zoneAdd: zoneAdd, addLists: addLists, addListResultData: addListResultData, 
            //
            companyClick: companyClick, zoneClick: zoneClick, listAdd: listAdd, listDelete: listDelete, siteAdd: siteAdd, addList: addList, setAddList: setAddList }));
    });
    // <!-- 신규 가입자 - enablde 팝업  --> 
    useEffect(() => {
        setParentPopWin("pop-enabled", React.createElement(EnabledPop, { htmlHeader: (item) && React.createElement("h1", null, "\uC0AC\uC6A9\uC790 \uC124\uC815"), htmlHeaderBtn: (item) && React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => closeBtn("pop-enabled") },
                React.createElement("span", { className: "hide" }, "\uB2EB\uAE30")), item: item, enableType: enableType, setReload: setReload, setEnableItem: setEnableItem }));
    });
    // <!-- 신규 가입자 - password 팝업  --> 
    useEffect(() => {
        setParentPopWin("pop-password", React.createElement(PassswordPop, { htmlHeader: (item) && React.createElement("h1", null, "\uD328\uC2A4\uC6CC\uB4DC \uCD08\uAE30\uD654"), htmlHeaderBtn: (item) && React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => closeBtn("pop-password") },
                React.createElement("span", { className: "hide" }, "\uB2EB\uAE30")), item: item, setReload: setReload, password: password }));
    });
    // <!-- 신규 가입자 - list 삭제 팝업  --> 
    useEffect(() => {
        setParentPopWin("pop-delete", React.createElement(DeletePop, { htmlHeader: (item) && React.createElement("h1", null, "\uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D"), htmlHeaderBtn: (item) && React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => closeBtn("pop-delete") },
                React.createElement("span", { className: "hide" }, "\uB2EB\uAE30")), item: item, setReload: setReload, userDel: userDel, addListResultData: addListResultData, setAddListResultData: setAddListResultData }));
    });
    // <!-- 신규 가입자 - 사용자 타입 팝업  --> 
    useEffect(() => {
        setParentPopWin("pop-role", React.createElement(RolePop, { htmlHeader: (item) && React.createElement("h1", null, "\uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D"), htmlHeaderBtn: (item) && React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => closeBtn("pop-delete") },
                React.createElement("span", { className: "hide" }, "\uB2EB\uAE30")), item: item, setReload: setReload, userTypeItme: userTypeItme, setUserType: setUserType, checked: checked, setChecked: setChecked, addListResultData: addListResultData, setAddListResultData: setAddListResultData, setUserLoad: setUserLoad }));
    });
    // 승인 API 
    function approvalChang(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/user/${list.id}/approval`,
                appQuery: {
                    approval: 2
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setApprovalNo(data.body.approval);
                    setReload(true);
                    setUserDisplayCompanion(false);
                    setUserDisplayDone(true);
                }
            }
        });
    }
    // 반려 display
    function onCompanion(e, list) {
        if (userDisplayCompanion === false) {
            setUserDisplayCompanion(true);
            setUserDisplayDone(false);
        }
        else if (list.enabled == false) {
            setUserDisplayCompanion(false);
        }
    }
    // 승인 선택
    function onDone(e) {
        if (userDisplayDone === false) {
            setUserDisplayDone(true);
            setUserDisplayCompanion(false);
            setCompanionTxt("");
        }
    }
    // 회사 API
    function companySelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: "/api/v2/product/companies",
                appQuery: {
                // language: apiLang,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCompanyItem(data.body);
                    var company = document.getElementById("company");
                    var companyhange = document.getElementById("company_change");
                    var zone = document.getElementById("zone");
                    var zoneChange = document.getElementById("zone_change");
                    company.click();
                    companyhange.classList.remove("hide");
                    companyhange.click();
                    companyhange.classList.add("hide");
                    zone.click();
                    zoneChange.classList.remove("hide");
                    zoneChange.click();
                    zoneChange.classList.add("hide");
                }
            }
        });
    }
    //회사 선택 시 사업장 API 연계까지
    function companyClick(e, company) {
        return __awaiter(this, void 0, void 0, function* () {
            if (company) {
                // 셀렉트 선택 시 data
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: "/api/v2/product/company/zones?companyId=" + company.companyId,
                    appQuery: {
                    // language: apiLang,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setZoneItem(data.body);
                        setCompanyAdd(company);
                        var zone = document.getElementById("zone");
                        var zoneChange = document.getElementById("zone_change");
                        zone.click();
                        zoneChange.classList.remove("hide");
                        zoneChange.click();
                        zoneChange.classList.add("hide");
                    }
                }
            }
        });
    }
    // 사업장 이벤트
    function zoneClick(e, zone) {
        setZoneAdd(zone);
    }
    //ApprovalPop - site addPop ListAdd
    function listAdd(e, companyAdd, zoneAdd, list) {
        const productId = addListResultData.map((val) => (val.productId));
        var listVal = {
            userIdPk: list.userIdPk,
            companyId: companyAdd.companyId,
            companyName: companyAdd.companyName,
            zoneId: zoneAdd.zoneId,
            zoneName: zoneAdd.zoneName,
            address: zoneAdd.address,
            // url: URL.createObjectURL(file),
        };
        if (zoneAdd != "") {
            if (productId.includes(listVal.zoneId)) {
                alert("회사_사업장 목록에 존재하여 등록이 불가능 합니다.");
            }
            else {
                setAddList([...addList, listVal]);
            }
        }
        // if()
    }
    //ApprovalPop - site addPop ListDelete
    function listDelete(list) {
        setAddList(addList.filter(delList => delList.zoneId !== list.zoneId));
        setAddListResult(addListResult.filter(delList => delList.zoneId !== list.zoneId));
    }
    // siet 등록 이벤트
    function siteAdd(addLists) {
        return __awaiter(this, void 0, void 0, function* () {
            setAddListResult(addLists);
            const popcloes = document.getElementsByClassName("js-close");
            popcloes;
        });
    }
    // 사용자 타입
    function usertypeSelect(e) {
        setErrorList(errorList.filter((err) => (err.field !== "role")));
        setUserType(e.target.value);
        setChecked(true);
    }
    // 승인 완료 
    function userApprovalDone(list, userType, addListResult) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/auth/user/${list.id}/roleusertree`,
                appQuery: {
                    role: userType,
                    usertree: addListResult.map((el) => ({
                        product: "zone",
                        productName: el.zoneName,
                        productParentId: el.companyId,
                        approval: 2,
                        isontree: true
                    }))
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("사용자 승인 요청이 완료되었습니다.");
                    setUserLoad(true);
                    var btnCommentClose_mng = document.getElementById("pop-userjoin-ok");
                    var body = document.body;
                    var dimm = body.querySelector(".dimm");
                    if (!CUTIL.isnull(btnCommentClose_mng))
                        btnCommentClose_mng.classList.add("hidden");
                    if (!CUTIL.isnull(body))
                        body.setAttribute("style", "overflow-y: auto;");
                    if (!CUTIL.isnull(dimm))
                        dimm.setAttribute("style", "display: none; z-index: 11;");
                    setAddList([]);
                    setAddListResult([]);
                }
                else {
                    setErrorList(data.errorList);
                }
            }
        });
    }
    //
    function close(e) {
        var btnCommentClose = document.getElementById("pop-userjoin-ok");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "display: none; z-index: 11;");
        var radioCheck = document.getElementById("rd_" + roleDto[0].id);
        setUserType((item.role == roleDto[4].value) ? "" : item.role);
        setChecked(false);
        setErrorList([]);
        setAddList([]);
        setAddListResult([]);
        setUserDisplayCompanion(false);
    }
    //
    //
    // 중복제거 이벤트
    const addLists = addList.filter((arr, index, callback) => index === callback.findIndex(t => t.zoneId === arr.zoneId));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype" },
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, selTree.company.companyName)),
            React.createElement("div", { className: "tbl__top mb-16" },
                React.createElement("div", { className: "left" },
                    React.createElement("div", { className: "searcharea" },
                        React.createElement("div", { className: "searchinput" },
                            React.createElement("span", { className: "mr-16" },
                                React.createElement("strong", null, "\uC0AC\uC5C5\uC7A5")),
                            React.createElement("div", { className: "select w186", onClick: (e) => { CUTIL.onClickSelect(e, CUTIL.selectOption), zoneOnSel(e); } },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value", onClick: (e) => setZoneName("") }, "\uC804\uCCB4"),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null,
                                    React.createElement("li", { className: "option", onClick: (e) => setZoneName("") }, "\uC804\uCCB4"),
                                    zoneSel.map((zone, idx) => (React.createElement("li", { key: "zone_" + idx, className: "option", onClick: (e) => setZoneName(zone.zoneName) }, zone.zoneName))))),
                            React.createElement("span", { className: "ml-76 mr-16" },
                                React.createElement("strong", null, "\uC0AC\uC6A9\uC790 \uD0C0\uC785")),
                            React.createElement("div", { className: "select w186", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value", onClick: (e) => setRole("") }, roleDto[0].fname),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, roleDto.map((role) => (React.createElement("li", { key: "role_" + role.id, className: "option", onClick: (e) => setRole(role.value) }, role.fname))))))))),
            React.createElement("div", { className: "tbl-list user-list" },
                React.createElement("table", { summary: "\uB4F1\uB85D \uC21C,\uC0AC\uC6A9\uC790 \uD0C0\uC785,\uD68C\uC0AC,\uC0AC\uC5C5\uC7A5,\uC774\uB984,E-mail(ID),\uC5F0\uB77D\uCC98,\uB2F4\uB2F9 \uC0AC\uC5C5\uC7A5,\uB9C8\uC9C0\uB9C9 \uB85C\uADF8\uC778,\uC2B9\uC778\uC0C1\uD0DC \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0AC\uC6A9\uC790 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC0AC\uC6A9\uC790 \uB9AC\uC2A4\uD2B8"),
                    React.createElement("colgroup", { className: "d-lm-none" },
                        React.createElement("col", { style: { "width": "90px" } }),
                        React.createElement("col", { style: { "width": "140px" } }),
                        React.createElement("col", { style: { "width": "" } }),
                        React.createElement("col", { style: { "width": "" } }),
                        React.createElement("col", { style: { "width": "90px" } }),
                        React.createElement("col", { style: { "width": "" } }),
                        React.createElement("col", { style: { "width": "145px" } }),
                        React.createElement("col", { style: { "width": "145px" } }),
                        React.createElement("col", { style: { "width": "" } }),
                        React.createElement("col", { style: { "width": "100px" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "rownumber") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left`, onClick: (e) => onClickSort(e), "data-value": "rownumber" },
                                React.createElement("span", null, "\uB4F1\uB85D \uC21C")),
                            React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "role") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left  pl-22`, onClick: (e) => onClickSort(e), "data-value": "role" },
                                React.createElement("span", null, "\uC0AC\uC6A9\uC790 \uD0C0\uC785")),
                            React.createElement("th", { scope: "col", className: `txt-left` },
                                React.createElement("span", null, "\uD68C\uC0AC")),
                            React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "zoneName") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left  d-sm-none`, onClick: (e) => onClickSort(e), "data-value": "zoneName" },
                                React.createElement("span", null, "\uC0AC\uC5C5\uC7A5")),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC774\uB984"),
                            React.createElement("th", { scope: "col", className: "txt-left d-lm-none" }, "E-mail(ID)"),
                            React.createElement("th", { scope: "col", className: "txt-left d-lm-none" }, "\uC5F0\uB77D\uCC98"),
                            React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "zoneCount") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left  d-sm-none`, onClick: (e) => onClickSort(e), "data-value": "zoneCount" },
                                React.createElement("span", null, "\uB2F4\uB2F9 \uC0AC\uC5C5\uC7A5")),
                            React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "loginTime") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left  d-sm-none`, onClick: (e) => onClickSort(e), "data-value": "loginTime" },
                                React.createElement("span", null, "\uB9C8\uC9C0\uB9C9 \uB85C\uADF8\uC778")),
                            React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "approval") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left `, onClick: (e) => onClickSort(e), "data-value": "approval" },
                                React.createElement("span", null, "\uC2B9\uC778\uC0C1\uD0DC")))),
                    React.createElement("tbody", null, (users) && users.map((list, idx) => (React.createElement("tr", { key: "userMng_" + idx, className: "js-open", "data-pop": "pop-userjoin-ok", onClick: (e) => approvalPop(e, list) },
                        React.createElement("td", { className: "txt-left", "data-pop": "pop-userjoin-ok" }, list.rowNumber),
                        React.createElement("td", { className: `txt-left ${(list.enable == false) && "icon-dot"} ${(list.role === roleDto[4].value || (list.enable == false)) && "disabled"}  pl-22`, "data-pop": "pop-userjoin-ok" },
                            React.createElement("span", { "data-pop": "pop-userjoin-ok" }, (roleDto.filter((rd) => (rd.value === list.role)).length > 0) ? roleDto.filter((rd) => (rd.value === list.role)).map((rd) => rd.fname) : roleDto[1].fname)),
                        React.createElement("td", { className: `txt-left ${(list.enable == false) && "icon-dot"} ${(list.role === roleDto[4].value || (list.enable == false)) && "disabled"}`, "data-pop": "pop-userjoin-ok" }, list.companyName),
                        React.createElement("td", { className: `txt-left ${(list.enable == false) && "icon-dot"} ${(list.role === roleDto[4].value || (list.enable == false)) && "disabled"} d-sm-none`, "data-pop": "pop-userjoin-ok" }, list.zoneName),
                        React.createElement("td", { className: `txt-left ${(list.enable == false) && "icon-dot"} ${(list.role === roleDto[4].value || (list.enable == false)) && "disabled"}`, "data-pop": "pop-userjoin-ok" }, list.userName),
                        React.createElement("td", { className: `txt-left ${(list.enable == false) && "icon-dot"} ${(list.role === roleDto[4].value || (list.enable == false)) && "disabled"} d-lm-none`, "data-pop": "pop-userjoin-ok" },
                            React.createElement("p", { className: "ellipsis", "data-pop": "pop-userjoin-ok" }, list.userId)),
                        React.createElement("td", { className: `txt-left ${(list.enable == false) && "icon-dot"} ${(list.role === roleDto[4].value || (list.enable == false)) && "disabled"} d-lm-none`, "data-pop": "pop-userjoin-ok" }, list.phoneNumber),
                        React.createElement("td", { className: `txt-left ${(list.enable == false) && "icon-dot"} ${(list.role === roleDto[4].value || (list.enable == false)) && "disabled"} d-sm-none`, "data-pop": "pop-userjoin-ok" }, list.zoneCount),
                        React.createElement("td", { className: `txt-left ${(list.enable == false) && "icon-dot"} ${(list.role === roleDto[4].value || (list.enable == false)) && "disabled"} d-sm-none`, "data-pop": "pop-userjoin-ok" },
                            React.createElement("p", { className: "ellipsis", "data-pop": "pop-userjoin-ok" }, CUTIL.utc2time("YYYY-MM-DD", list.loginTime))),
                        React.createElement("td", null, (list.approval == 1) ?
                            React.createElement("button", { type: "button", className: "bg-blue js-open", "data-pop": "pop-userjoin-ok" },
                                React.createElement("span", { "data-pop": "pop-userjoin-ok" }, "\uC2B9\uC778 \uC694\uCCAD"))
                            : (list.approval == 2) ?
                                React.createElement("button", { type: "button", className: "bg-navy js-open", "data-pop": "pop-userjoin-ok" },
                                    React.createElement("span", { "data-pop": "pop-userjoin-ok" }, "\uC2B9\uC778 \uC911"))
                                :
                                    ""))))))),
            (pageInfo) && React.createElement(EhpPagination, { componentName: "User", pageInfo: pageInfo, handleFunc: handleCurPage }))));
}
//
//신규 가입자요청 팝업
function RequestApproval(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const item = (props.item == null) ? null : props.item;
    const setItem = props.setItem;
    const setReload = props.setReload;
    const setEnableItem = props.setEnableItem;
    const addListResultData = props.addListResultData;
    const setPassword = props.setPassword;
    const companionTxt = props.companionTxt;
    const setErrorList = props.setErrorList;
    const userType = props.userType;
    const addListResult = props.addListResult;
    const setAddListResult = props.setAddListResult;
    const setUserDel = props.setUserDel;
    const enableItem = props.enableItem;
    const reload = props.reload;
    const userApprovalDone = props.userApprovalDone;
    const setUserType = props.setUserType;
    const checked = props.checked;
    const setChecked = props.setChecked;
    const setUserTypeItme = props.setUserTypeItme;
    const userLoad = props.userLoad;
    const setUserLoad = props.setUserLoad;
    const approvalNo = props.approvalNo;
    const setEnableIType = props.setEnableIType;
    const errorList = props.errorList;
    const setAddList = props.setAddList;
    const userDisplayDone = props.userDisplayDone;
    const setUserDisplayDone = props.setUserDisplayDone;
    const userDisplayCompanion = props.userDisplayCompanion;
    const setUserDisplayCompanion = props.setUserDisplayCompanion;
    const onDone = props.onDone;
    const approvalChang = props.approvalChang;
    const onCompanion = props.onCompanion;
    const setload = props.setload;
    const setAddListResultData = props.setAddListResultData;
    //
    //
    const [list, setList] = useState(null);
    // user item API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/user/${item.userIdPk}/detail`,
        userToken: userInfo.loginInfo.token,
        watch: item.userIdPk + reload + enableItem + userLoad
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setList(data.body);
                setAddListResultData(data.body.userTreeList);
                setUserType(data.body.role);
            }
            else {
                if (data.errorList.filter((err) => (err.field == "userId"))) {
                }
                else {
                    alert(data.errorList.map((err) => (err.msg)));
                    CUTIL.jsclose_Popup("pop-userjoin-ok");
                }
                /*        var btnCommentClose_mng = document.getElementById("pop-userjoin-ok");
                       var body = document.body
                       var dimm = body.querySelector(".dimm");
               
                       if (!CUTIL.isnull(btnCommentClose_mng)) btnCommentClose_mng.classList.add("hidden");
                       if (!CUTIL.isnull(body)) body.setAttribute("style", "overflow-y: auto;");
                       if (!CUTIL.isnull(dimm)) dimm.setAttribute("style", "display: none; z-index: 11;"); */
            }
        }
    }, [data]);
    //
    // 반려 완료
    function userApprovalDel(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/user/${list.id}/approval`,
                appQuery: {
                    approval: 0,
                    deniedReason: companionTxt
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("메일 전송이 완료되었습니다.");
                    var btnCommentClose_mng = document.getElementById("pop-userjoin-ok");
                    var body = document.body;
                    var dimm = body.querySelector(".dimm");
                    setload(true);
                    if (!CUTIL.isnull(btnCommentClose_mng))
                        btnCommentClose_mng.classList.add("hidden");
                    if (!CUTIL.isnull(body))
                        body.setAttribute("style", "overflow-y: auto;");
                    if (!CUTIL.isnull(dimm))
                        dimm.setAttribute("style", "display: none; z-index: 11;");
                }
            }
        });
    }
    // 승인 수정 
    function userApprovalUpdate(list, userType, addListResult) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/auth/user/${list.id}/roleusertree`,
                appQuery: {
                    role: userType,
                    usertree: addListResult.map((el) => ({
                        product: "zone",
                        productName: el.zoneName,
                        productParentId: el.companyId,
                        approval: 2,
                        isontree: true
                    }))
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("사용자 승인 요청이 수정되었습니다.");
                    setReload(true);
                    setUserLoad(true);
                    var btnCommentClose_mng = document.getElementById("pop-userjoin-ok");
                    var body = document.body;
                    var dimm = body.querySelector(".dimm");
                    if (!CUTIL.isnull(btnCommentClose_mng))
                        btnCommentClose_mng.classList.add("hidden");
                    if (!CUTIL.isnull(body))
                        body.setAttribute("style", "overflow-y: auto;");
                    if (!CUTIL.isnull(dimm))
                        dimm.setAttribute("style", "display: none; z-index: 11;");
                    setAddListResult([]);
                    setAddList([]);
                }
                else {
                    setErrorList(data.errorList);
                }
            }
        });
    }
    //
    function userOnOff(e, type) {
        CUTIL.jsopen_Popup(e);
        setEnableIType(type);
    }
    function userPwd(e, type) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.jsopen_Popup(e);
            setPassword(type);
        });
    }
    return (React.createElement(React.Fragment, null,
        (list) &&
            React.createElement("div", { className: `popup__body ${(list.enabled === false) ? "alldisabled" : ""}` },
                React.createElement("div", { className: "left" },
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "E-mail (\uC544\uC774\uB514)"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp1", value: list.userId, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp2", value: list.userName, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC5F0\uB77D\uCC98"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp3", value: list.phoneNumber, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uD68C\uC0AC"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp4", value: list.companyName, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp5", value: list.zoneName, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBD80\uC11C"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp6", value: list.department, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC5C5\uC885"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp7", value: list.classification, disabled: true }))),
                        (list.approval != 3) ?
                            React.createElement("li", { className: "mt-45" },
                                React.createElement("p", { className: "tit star mt-8" }, "\uC2B9\uC778 \uC5EC\uBD80"),
                                React.createElement("div", { className: "btn__wrap" },
                                    (list.approval == 2 && list.enabled == true) &&
                                        React.createElement("button", { type: "button", className: (userDisplayDone) ? "bg-navy" : "", onClick: (e) => onDone(e) },
                                            React.createElement("span", null, "\uC2B9\uC778")),
                                    (list.approval == 1 && list.enabled == true) &&
                                        React.createElement("button", { type: "button", onClick: (e) => approvalChang(list) },
                                            React.createElement("span", null, "\uC2B9\uC778")),
                                    React.createElement("button", { type: "button", className: (userDisplayCompanion) ? "bg-navy" : "", onClick: (e) => onCompanion(e, list) },
                                        React.createElement("span", null, "\uBC18\uB824"))))
                            :
                                React.createElement("li", { className: "mt-45" },
                                    React.createElement("p", { className: "tit mt-8 txt-black" }, "\uC0AC\uC6A9\uC790 \uC124\uC815"),
                                    React.createElement("div", { className: "btn__wrap left-right" },
                                        (list.enabled == false) &&
                                            React.createElement("button", { type: "button", className: "btn-off js-open", "data-pop": "pop-enabled", onClick: (e) => userOnOff(e, list.enabled) },
                                                React.createElement("span", { className: "hide js-open", "data-pop": "pop-enabled" }, "\uBE44\uD65C\uC131\uD654")),
                                        (list.enabled == true) &&
                                            React.createElement("button", { type: "button", className: "btn-on js-open", "data-pop": "pop-enabled", onClick: (e) => userOnOff(e, list.enabled) },
                                                React.createElement("span", { className: "hide" }, "\uD65C\uC131\uD654")),
                                        React.createElement("button", { type: "button", className: "btn txtline js-open", "data-pop": "pop-password", onClick: (e) => userPwd(e, list) },
                                            React.createElement("span", { "data-pop": "pop-password" }, "\uD328\uC2A4\uC6CC\uB4DC \uCD08\uAE30\uD654")))))),
                React.createElement("div", { className: "right" },
                    React.createElement("ul", { className: "form__input" },
                        (userDisplayCompanion) &&
                            React.createElement(Companion, { companionTxt: props.companionTxt, setCompanionTxt: props.setCompanionTxt }),
                        (list.approval != 1 && userDisplayDone && list.enabled == true) &&
                            React.createElement(IsSavedApproval, { list: list, addListResult: props.addListResult, errorList: errorList, 
                                //
                                companySelect: props.companySelect, userType: props.userType, setUserType: setUserType, checked: checked, setChecked: setChecked, usertypeSelect: props.usertypeSelect, roleDto: props.roleDto, listDelete: props.listDelete, reload: props.reload, addListResultData: addListResultData, setUserDel: setUserDel, setUserTypeItme: setUserTypeItme })))),
        (list) &&
            React.createElement("div", { className: "popup__footer" }, (userDisplayCompanion && props.companionTxt) ?
                React.createElement("button", { type: "button", onClick: (e) => userApprovalDel(list) },
                    React.createElement("span", null, "\uC644\uB8CC"))
                : (userDisplayDone && list.approval == 2 && (list.enabled === true)) ?
                    React.createElement("button", { type: "button", onClick: (e) => userApprovalDone(list, userType, addListResult) },
                        React.createElement("span", null, "\uC644\uB8CC"))
                    : (list.approval == 3 && (list.enabled === true)) ?
                        React.createElement("button", { type: "button", onClick: (e) => userApprovalUpdate(list, userType, addListResult) },
                            React.createElement("span", null, "\uC644\uB8CC"))
                        : (list.enabled === false) ?
                            React.createElement("button", { type: "button", disabled: true },
                                React.createElement("span", null, "\uC644\uB8CC"))
                            :
                                React.createElement("button", { type: "button", disabled: true },
                                    React.createElement("span", null, "\uC644\uB8CC")))));
}
//신규 가입자 승인 
function IsSavedApproval(props) {
    const list = (props.list == null) ? null : props.list;
    const addListResult = (props.addListResult == null) ? null : props.addListResult;
    const companySelect = props.companySelect;
    const checked = props.checked;
    const setChecked = props.setChecked;
    const listDelete = props.listDelete;
    const roleDto = props.roleDto;
    const errorList = props.errorList;
    const addListResultData = props.addListResultData;
    const userType = props.userType;
    const setUserDel = props.setUserDel;
    const setUserTypeItme = props.setUserTypeItme;
    //
    const [userTree, setUserTree] = useState([]);
    useEffect(() => {
        setUserTree(addListResultData);
    }, [addListResultData]);
    function listItemDelete(e, list) {
        CUTIL.jsopen_Popup(e);
        setUserDel(list);
    }
    function usertypePop(e) {
        CUTIL.jsopen_Popup(e);
        setUserTypeItme(e.target.value);
        setChecked(true);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("li", null,
            React.createElement("p", { className: "tit star question" },
                React.createElement("span", null, "\uC0AC\uC6A9\uC790 \uD0C0\uC785")),
            React.createElement("div", { className: "input__area" },
                React.createElement("div", { className: (errorList.filter(err => (err.field === "role")).length > 0) ? "radioBox input-error" : "radioBox" },
                    React.createElement("label", { id: "rd_" + roleDto[0].id, className: "hide" },
                        React.createElement("input", { type: "radio", id: "rd_" + roleDto[0].id, name: "rd", value: roleDto[0].value, checked: !checked, onChange: (e) => props.usertypeSelect(e) })),
                    (list.approval === 2) && roleDto.filter((type) => (type.id != 4) && (type.id != 0)).map((type) => (React.createElement("label", { id: "rd_" + type.id, key: type.id },
                        (list.enabled == false) ?
                            React.createElement("input", { type: "radio", disabled: true, id: "rd_" + type.id, name: "rd" })
                            :
                                React.createElement("input", { type: "radio", id: "rd_" + type.id, name: "rd", value: (type.value === userType) ? type.value : type.value, checked: (userType === type.value) ? true : false, onChange: (e) => props.usertypeSelect(e) }),
                        type.fname))),
                    (list.approval == 3) && roleDto.filter((type) => (type.id != 4) && (type.id != 0)).map((type) => (React.createElement("label", { id: "rd_" + type.id, key: type.id },
                        (list.enabled == false) ?
                            React.createElement("input", { type: "radio", disabled: true, id: "rd_" + type.id, name: "rd", checked: (list.role == type.value) && true })
                            :
                                React.createElement("input", { type: "radio", id: "rd_" + type.id, name: "rd", value: (type.value === list.role) ? type.value : type.value, 
                                    // checked={(list.role === type.value) ? type.value : (userType === type.value) ? !checked : checked} onChange={(e) => usertypePop(e)} />
                                    checked: (userType === type.value) ? true : false, onChange: (e) => usertypePop(e), className: "js-open", "data-pop": "pop-role" }),
                        type.fname)))),
                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "role")).map((err) => err.msg)))),
        React.createElement("li", { className: "inline" },
            React.createElement("p", { className: "tit " }, "\uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D"),
            (userType == roleDto[3].value) && (list.enabled == true) ?
                React.createElement("button", { type: "button", className: "btn-basic js-open d-sm-none", "data-pop": "pop-userjoin-info", onClick: (e) => { CUTIL.jsopen_Popup(e), companySelect(e); } },
                    React.createElement("span", { "data-pop": "pop-userjoin-info" }, "\uCD94\uAC00"))
                :
                    React.createElement("button", { type: "button", className: "btn-basic", disabled: true },
                        React.createElement("span", null, "\uCD94\uAC00"))),
        React.createElement("li", { className: "mb-0" },
            React.createElement("div", { className: "tbl-list type2 mt-m10" },
                React.createElement("table", { summary: "No.,\uD68C\uC0AC \uBA85,\uC0AC\uC5C5\uC7A5 \uBA85 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C Sites \uCD94\uAC00 \uC815\uBCF4 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC0AC\uC5C5\uC7A5 \uC2B9\uC778 \uC694\uCCAD\uC790 \uC815\uBCF4 \uBAA9\uB85D"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: {} })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" }, "No."),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uD68C\uC0AC \uBA85"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                            React.createElement("th", { scope: "col", className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C"))),
                    React.createElement("tbody", null,
                        (userTree) && userTree.map((treeList, idx) => (React.createElement("tr", { key: treeList.id },
                            React.createElement("td", { className: "txt-left" }, ++idx),
                            React.createElement("td", { className: "txt-left" }, treeList.productParentId),
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("span", { className: "icon-navi" }, treeList.productName)),
                            React.createElement("td", null, (list.enabled == true) ?
                                React.createElement("button", { type: "button", className: "bg-gray js-open", "data-pop": "pop-delete", onClick: (e) => listItemDelete(e, treeList) },
                                    React.createElement("span", { "data-pop": "pop-delete" }, "\uC0AD\uC81C"))
                                :
                                    React.createElement("button", { type: "button", className: "bg-gray", disabled: true },
                                        React.createElement("span", null, "\uC0AD\uC81C")))))),
                        (addListResult) && addListResult.map((list, idx) => (React.createElement("tr", { key: list.zoneId },
                            React.createElement("td", { className: "txt-left" }, (userTree.length + ++idx)),
                            React.createElement("td", { className: "txt-left" }, list.companyName),
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("span", { className: "icon-navi" }, list.zoneName)),
                            React.createElement("td", null,
                                React.createElement("button", { type: "button", className: "btn-delete-g", onClick: (e) => listDelete(list) },
                                    React.createElement("span", { className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C")))))))))),
        React.createElement("li", { className: "mt-8" },
            React.createElement("p", { className: "txt-info" }, "* \uC0AC\uC6A9\uC790 \uD0C0\uC785 \uBCC0\uACBD \uC2DC User\uB85C \uB4F1\uB85D\uB41C \uD68C\uC0AC_\uC0AC\uC5C5\uC7A5\uC740 \uCD08\uAE30\uD654 \uB429\uB2C8\uB2E4."))));
}
// 신규가입자- 반려
function Companion(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("li", { className: "inline" },
            React.createElement("p", { className: "tit star" }, "\uBC18\uB824 \uC0AC\uC720 \uC785\uB825")),
        React.createElement("li", null,
            React.createElement("div", { className: "input__area w100p" },
                React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694", value: props.companionTxt, onChange: (e) => props.setCompanionTxt(e.target.value) })))));
}
//신규 가입자 - site 등록
function SiteCeatePop(props) {
    //props
    const item = (props.item == null) ? null : props.item;
    const companyItems = (props.companyItem === null) ? null : props.companyItem;
    const zoneItems = (props.zoneItem === null) ? null : props.zoneItem;
    const addLists = (props.addLists === null) ? null : props.addLists;
    const addListResultData = props.addListResultData;
    //
    const companyAdd = props.companyAdd;
    const zoneAdd = props.zoneAdd;
    const addList = props.addList;
    const setAddList = props.setAddList;
    //
    const companyClick = props.companyClick;
    const zoneClick = props.zoneClick;
    const listAdd = props.listAdd;
    const listDelete = props.listDelete;
    const siteAdd = props.siteAdd;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body layout-vertical" },
            React.createElement("ul", { className: "form__input inline mb-24" },
                React.createElement("li", null,
                    React.createElement("label", { htmlFor: "company" },
                        React.createElement("span", { className: "star" }, "\uD68C\uC0AC")),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("div", { id: "company", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                            React.createElement("div", { className: "selected" },
                                React.createElement("div", { className: "selected-value" }, "\uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD574\uC8FC\uC138\uC694"),
                                React.createElement("div", { className: "arrow" })),
                            React.createElement("ul", { className: "hmax-385" },
                                React.createElement("li", { id: "company_change", className: "option hide", onClick: (e) => companyClick(e, "") }, "\uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD574\uC8FC\uC138\uC694"),
                                companyItems.map((list) => (React.createElement("li", { key: list.companyId, className: "option", onClick: (e) => companyClick(e, list) }, list.companyName))))))),
                React.createElement("li", null,
                    React.createElement("label", { htmlFor: "company" },
                        React.createElement("span", { className: "star" }, "\uC0AC\uC5C5\uC7A5")),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("div", { id: "zone", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                            React.createElement("div", { className: "selected" },
                                React.createElement("div", { className: "selected-value" }, "\uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD574\uC8FC\uC138\uC694"),
                                React.createElement("div", { className: "arrow" })),
                            React.createElement("ul", { className: "hmax-385" },
                                React.createElement("li", { id: "zone_change", className: "option hide", onClick: (e) => zoneClick(e, "") }, "\uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD574\uC8FC\uC138\uC694"),
                                zoneItems.map((list) => (React.createElement("li", { key: list.zoneId, className: "option", onClick: (e) => zoneClick(e, list) }, list.zoneName)))))),
                    React.createElement("button", { type: "button", className: "btn-basic ml-18", onClick: (e) => listAdd(e, companyAdd, zoneAdd, item) },
                        React.createElement("span", null, "\uCD94\uAC00")))),
            React.createElement("div", { className: "tbl-list type2" },
                React.createElement("table", { summary: "No.,\uD68C\uC0AC \uBA85,\uC0AC\uC5C5\uC7A5\uBA85, \uC0AC\uC5C5\uC7A5 \uC8FC\uC18C, \uD56D\uBAA9\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC2E0\uADDC \uAC00\uC785\uC790 \uC815\uBCF4 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC2E0\uADDC \uAC00\uC785\uC790 \uC815\uBCF4 \uBAA9\uB85D"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: {} })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" }, "No."),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uD68C\uC0AC \uBA85"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                            React.createElement("th", { scope: "col", className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C"))),
                    React.createElement("tbody", null, (addLists) && addLists.map((list, idx) => (React.createElement("tr", { key: list.zoneId },
                        React.createElement("td", { className: "txt-left" }, ++idx),
                        React.createElement("td", { className: "txt-left" }, list.companyName),
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("span", { className: "icon-navi" }, list.zoneName)),
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("p", { className: "ellipsis" }, list.address)),
                        React.createElement("td", null,
                            React.createElement("button", { type: "button", className: "btn-delete-g", onClick: (e) => listDelete(list) },
                                React.createElement("span", { className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C")))))))))),
        React.createElement("div", { className: "popup__footer right" },
            React.createElement("button", { type: "button", className: "js-close bg-linegray", onClick: (e) => closeBtn("pop-userjoin-info") },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "js-close", onClick: (e) => siteAdd(addLists) },
                React.createElement("span", null, "\uB4F1\uB85D")))));
}
function EnabledPop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const item = props.item;
    const enableType = props.enableType;
    const setReload = props.setReload;
    const setEnableItem = props.setEnableItem;
    function onClickEnalbe(enableItem) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/user/${enableItem.userIdPk}/enable`,
                appQuery: {
                    enabled: !enableItem.enabled
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setEnableItem(data.body.enabled);
                    var btnCommentClose = document.getElementById("pop-enabled");
                    var body = document.body;
                    var dimm = body.querySelector(".dimm");
                    if (!CUTIL.isnull(body))
                        body.setAttribute("style", "overflow-y: hidden;");
                    if (!CUTIL.isnull(dimm))
                        dimm.setAttribute("style", "display: block; z-index: 30;");
                    if (!CUTIL.isnull(btnCommentClose))
                        btnCommentClose.classList.add("hidden");
                }
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        (item) &&
            React.createElement("div", { className: "popup__body" },
                React.createElement("p", null,
                    "\uD574\uB2F9 \uC0AC\uC6A9\uC790\uB97C ",
                    (enableType == true) ? "비활성화" : "활성화",
                    "\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"),
                React.createElement("p", null,
                    (enableType == true) ? "비활성화" : "활성화",
                    " \uC2DC \uC0AC\uC6A9\uC790\uC758 e-Health- Portal \uC0AC\uC6A9\uC774 ",
                    (enableType == true) ? "정지" : "승인",
                    "  \uB429\uB2C8\uB2E4.")),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => closeBtn("pop-enabled") },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "close", onClick: (e) => onClickEnalbe(item) },
                React.createElement("span", null, "\uD655\uC778")))));
}
function PassswordPop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const item = props.item;
    const setReload = props.setReload;
    const password = props.password;
    const [passwordItem, setPaaswordItem] = useState(null);
    function onClickDone(type) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/auth/user/${type.id}/password/init`,
                /*    appQuery: {
                   }, */
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setPaaswordItem(data.body);
                }
            }
        });
    }
    function onClickPwdDone(e) {
        var btnCommentClose = document.getElementById("pop-password");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: hidden;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "display: block; z-index: 30;");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
        setPaaswordItem(null);
    }
    return (React.createElement(React.Fragment, null,
        (item) &&
            React.createElement("div", { className: "popup__body" },
                React.createElement("p", null,
                    "\uD574\uB2F9 \uC0AC\uC6A9\uC790 \uD328\uC2A4\uC6CC\uB4DC\uAC00 \uCD08\uAE30\uD654 ",
                    (!passwordItem) ? "하시겠습니까?" : "되었습니다."),
                (passwordItem) && React.createElement("p", null,
                    "\uCD08\uAE30\uD654 \uBE44\uBC00\uBC88\uD638 : ",
                    React.createElement("b", null, passwordItem.passwordInit))),
        React.createElement("div", { className: "popup__footer" },
            (!passwordItem) &&
                React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => closeBtn("pop-password") },
                    React.createElement("span", null, "\uCDE8\uC18C")),
            (!passwordItem) ?
                React.createElement("button", { type: "button", className: "close", onClick: (e) => onClickDone(password) },
                    React.createElement("span", null, "\uD655\uC778"))
                :
                    React.createElement("button", { type: "button", className: "close", onClick: (e) => onClickPwdDone(e) },
                        React.createElement("span", null, "\uC644\uB8CC")))));
}
function DeletePop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const item = props.item;
    const setReload = props.setReload;
    const userDel = props.userDel;
    const addListResultData = props.addListResultData;
    const setAddListResultData = props.setAddListResultData;
    function onClickDone(e, userDel) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/api/v2/product/usertree/user/${item.userIdPk}`,
                appQuery: {
                    productId: userDel.productId
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("데이터가 삭제되었습니다.");
                    setAddListResultData(addListResultData.filter(delList => delList.productId !== userDel.productId));
                    var btnCommentClose = document.getElementById("pop-delete");
                    var body = document.body;
                    var dimm = body.querySelector(".dimm");
                    if (!CUTIL.isnull(body))
                        body.setAttribute("style", "overflow-y: hidden;");
                    if (!CUTIL.isnull(dimm))
                        dimm.setAttribute("style", "display: block; z-index: 30;");
                    if (!CUTIL.isnull(btnCommentClose))
                        btnCommentClose.classList.add("hidden");
                }
                else {
                    // 기존 기기 존재 시
                    if (data.codeNum == 9999) {
                        alert(data.body.errorList[0].msg);
                        var btnCommentClose = document.getElementById("pop-delete");
                        var body = document.body;
                        var dimm = body.querySelector(".dimm");
                        if (!CUTIL.isnull(body))
                            body.setAttribute("style", "overflow-y: hidden;");
                        if (!CUTIL.isnull(dimm))
                            dimm.setAttribute("style", "display: block; z-index: 30;");
                        if (!CUTIL.isnull(btnCommentClose))
                            btnCommentClose.classList.add("hidden");
                    }
                }
            }
            /*
            
             */
        });
    }
    return (React.createElement(React.Fragment, null,
        (item) &&
            React.createElement("div", { className: "popup__body" },
                React.createElement("p", null, "\uB4F1\uB85D\uD55C \uD68C\uC0AC_\uC0AC\uC5C5\uC7A5\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?")),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => closeBtn("pop-delete") },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "close", onClick: (e) => onClickDone(e, userDel) },
                React.createElement("span", null, "\uD655\uC778")))));
}
function RolePop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const item = props.item;
    const setReload = props.setReload;
    const userTypeItme = props.userTypeItme;
    const addListResultData = props.addListResultData;
    const setAddListResultData = props.setAddListResultData;
    const setUserType = props.setUserType;
    const checked = props.checked;
    const setChecked = props.setChecked;
    const setUserLoad = props.setUserLoad;
    function onClickDone(e, userTypeItme) {
        return __awaiter(this, void 0, void 0, function* () {
            setUserType(userTypeItme);
            setChecked(checked);
            setAddListResultData([]);
            var btnCommentClose = document.getElementById("pop-role");
            var body = document.body;
            var dimm = body.querySelector(".dimm");
            if (!CUTIL.isnull(body))
                body.setAttribute("style", "overflow-y: hidden;");
            if (!CUTIL.isnull(dimm))
                dimm.setAttribute("style", "display: block; z-index: 30;");
            if (!CUTIL.isnull(btnCommentClose))
                btnCommentClose.classList.add("hidden");
        });
    }
    return (React.createElement(React.Fragment, null,
        (item) &&
            React.createElement("div", { className: "popup__body" },
                React.createElement("p", null, "\uD574\uB2F9 \uC0AC\uC6A9\uC790 \uD0C0\uC785\uC744 \uBCC0\uACBD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uB07C?"),
                React.createElement("p", null, "\uBCC0\uACBD \uC2DC \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uB4F1\uB85D\uB41C  \uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D\uC774 \uCD08\uAE30\uD654 \uB429\uB2C8\uB2E4.")),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => closeBtn("pop-role") },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "close", onClick: (e) => onClickDone(e, userTypeItme) },
                React.createElement("span", null, "\uD655\uC778")))));
}
function closeBtn(type) {
    var btnCommentClose = document.getElementById(type);
    var body = document.body;
    var dimm = body.querySelector(".dimm");
    if (!CUTIL.isnull(btnCommentClose))
        btnCommentClose.classList.add("hidden");
    if (!CUTIL.isnull(body))
        body.setAttribute("style", "overflow-y: hidden;");
    if (!CUTIL.isnull(dimm))
        dimm.setAttribute("style", "display: block; z-index: 30;");
}
